import { SET_USER, UNSET_USER, SET_LOGIN_ERROR } from '../types'

// const session = sessionStorage.getItem('user')
// const user = session ? JSON.parse(session) : {}
// const isAuth = session ? true : undefined

const initialState = {
    user: {},
    isAuth: undefined,
    errors: {}
}

export const auth = (state = initialState, action) => {
    switch (action.type) {
        case SET_USER:
            return {
              ...state,
              user: action.payload,
              isAuth: true
            }
        case SET_LOGIN_ERROR:
          return {
            ...state,
            errors: {
              ...action.payload
            }
          }
        case UNSET_USER:
          return {
            user: {},
            isAuth: undefined,
            errors: {}
          }
        default:
            return state;
    }
}